/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MapsGotoSlack = lazyLoad(
  () => import('./index'),
  module => module.MapsGotoSlack,
);
